// removed by extract-text-webpack-plugin
module.exports = {"cursorPointer":"styles__cursorPointer___x09Is"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Modal/styles.css
// module id = 778
// module chunks = 0